import React from 'react';
import PropTypes from 'prop-types';

export const Star = props => (
    <span className="rating-stars__star rating-star">
        <span
            className="rating-star__foreground"
            style={{ width: Math.floor(props.fullness * 100) + '%' }}
        />
        <span className="rating-star__background" />
    </span>
);

Star.propTypes = {
    fullness: PropTypes.number,
};

Star.defaultProps = {
    fullness: 100,
};
